<template>
  <main class="stage">
    <section class="slide animated fadeIn" :style="{
        transform: `translate(-50%, -50%) scale(${zoom})`
        }">
      <template v-if="loading">
        <v-progress-circular :size="70" :width="7" color="purple" indeterminate></v-progress-circular>
      </template>
      <h1 class="display-1" v-else>{{$route.params.slide}}
    
    ----------
    single slide {{slide.name}}
    <v-text-field v-model="slide.name" />
    <v-btn @click="save">save</v-btn>
    </h1>    
  
    </section>
  </main>
  <!--h1 class="display-1" v-if="!loading">{{$route.params.slide}}
    
    ----------
    single slide {{slide.name}}
    <v-text-field v-model="slide.name" />
    <v-btn @click="save">save</v-btn>
    </h1>    
    <v-progress-circular
        v-else
      :size="70"
      :width="7"
      color="purple"
      indeterminate
  ></v-progress-circular-->
</template>
<style scoped lang="scss">
.stage {
  height: 100vh;
  width: 100vw;
  background-color: black;
  overflow: auto;
  .slide {
    width: 1920px;
    height: 1080px;
    background-color: lime;    
    position: absolute;
    top: 50%; 
    left: 50%;
  }
}
</style>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      slides: {},
      loading: false,
      zoom: 1
    };
  },
  methods: {
    ...mapActions("slides", ["insert", "set", "delete", "fetchById", "patch"]),
    async save() {
      try {
        let data = {
          id: this.$route.params.slideid,
          ...this.$store.state.slides.data[this.$route.params.slideid]
        };
        console.log(data);

        await this.patch(data);
      } catch (e) {
        alert(e);
      }
    },
    zoomInViewPort() {
      let FULLDWIDTH = 1920;
      let windowWith = window.innerWidth;
      
      if (windowWith < FULLDWIDTH) {
        let scale = windowWith / FULLDWIDTH;
        this.zoom = scale;
      }
    }
  },
  watch: {
    async $route() {
      console.log("loaidng");
      this.loading = true;
      let slide = await this.fetchById(slideId);
      this.loading = false;
      console.log("loaidng finished");      
    }
  },
  computed: {
    slide() {
      const slideid = this.$route.params.slideid;
      return this.$store.state.slides.data[slideid].slides.find(
        item => item.uuid === this.$route.params.slide
      );
    },
    zoomLevel() {
      return this.$store.state.application.zoomLevel;
    }
  },
  async created() {
    let slideId = this.$route.params.slideid;
    this.loading = true;
    let slide = await this.fetchById(slideId);
    this.loading = false;
    this.zoomInViewPort();
    window.addEventListener('resize',this.zoomInViewPort);
  }
};
</script>